import React from 'react'
import { Route, Switch } from 'react-router-dom'

import NovoPed from '../PED/NovoPed'
import BuscaPed from '../PED/BuscaPed'
import DocumentosPed from '../PED/DocumentosPed'
import CapaPed from '../PED/CapaPed'
import RelatorRevisor from '../Nomeacoes/RelatorRevisor'
import RelatorRevisorView from '../Nomeacoes/RelatorRevisorView'
import Instrutor from '../Nomeacoes/Instrutor'
import InstrutorView from '../Nomeacoes/InstrutorView'
import NovoAnexo from '../Anexos/NovoAnexo'
import AnexoView from '../Anexos/AnexoView'
import Home from '../Home/Home'
import NovoChamado from '../Suporte/NovoChamado'
import MeusChamados from '../Suporte/MeusChamados'
import Chamado from '../Suporte/Chamado'
import Senha from '../Senha/Senha'
import EnviarMensagem from '../Mensagem/EnviarMensagem'
import MinhasMensagens from '../Mensagem/MinhasMensagens'
import Mensagem from '../Mensagem/Mensagem'
import Impressao from '../Impressao/Impressao'
import Dash from '../Dashboard/Dash'

export default class Content extends React.Component {
    render() {
        return (
            <Switch>
                <Route exact path='/etica' component={Home} />
                <Route exact path='/etica/dash' component={Dash} />
                <Route exact path="/etica/novoPed" component={NovoPed} />
                <Route exact path="/etica/buscaPed" component={BuscaPed} />
                <Route exact path={`/etica/documentosPed/:id`} component={DocumentosPed} />
                <Route exact path={`/etica/capaPed/:id`} component={CapaPed} />
                <Route exact path={`/etica/relatorRevisor/:id`} component={RelatorRevisor} />
                <Route exact path={`/etica/relatorRevisorView/:id`} component={RelatorRevisorView} />
                <Route exact path={`/etica/instrutor/:id`} component={Instrutor} />
                <Route exact path={`/etica/instrutorView/:id`} component={InstrutorView} />
                <Route exact path={`/etica/novoAnexo/:id`} component={NovoAnexo} />
                <Route exact path={`/etica/anexoView/:id`} component={AnexoView} />
                <Route exact path="/etica/novoChamado" component={(NovoChamado)} />
                <Route exact path='/etica/meusChamados' component={MeusChamados} />
                <Route exact path={`/etica/chamado/:id`} component={Chamado} />
                <Route exact path='/etica/senha' component={Senha} />
                <Route exact path='/etica/enviarMensagem' component={EnviarMensagem} />
                <Route exact path='/etica/minhasMensagens' component={MinhasMensagens} />
                <Route exact path={`/etica/mensagem/:id`} component={Mensagem} />
                <Route exact path={`/etica/impressao/:id`} component={Impressao} />
            </Switch>
        )
    }
}